import { Helmet } from "react-helmet-async";
import { SITE } from "../data/site";

// URL-Konvention: einheitlich OHNE Slash am Ende (Ausnahme: Startseite "/").
// Canonical, og:url und interne Links folgen alle dieser Normalform.
export const cleanPath = (p) => {
  const c = String(p || "/").replace(/\/+$/, "");
  return c || "/";
};

export const Seo = ({ title, description, path = "/", jsonLd, noindex, canonicalPath }) => {
  const canonical = cleanPath(canonicalPath || path);
  const pagePath = cleanPath(path);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE.domain}${canonical}`} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${SITE.domain}${pagePath}`} />
      <meta property="og:type" content="website" />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE.domain}${cleanPath(item.path)}`,
  })),
});
